module.exports = __webpack_public_path__ + "img/persol.6a8f5513.png";